import API from '../util/ApiUtil';
import { getCommonApiUrl } from '../util/UrlUtil';
import PropStateStore from './PropStateStore';
import TranslateStore from './TranslateStore';
import { MobXProviderContext } from 'mobx-react';
import React from 'react';
import FieldValidationStore from './FieldValidationStore';
export class NoticeRootStore {
    constructor(stateProps) {
        Object.defineProperty(this, "propStateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fieldValidationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "api", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.api = API(getCommonApiUrl(stateProps.env));
        this.propStateStore = new PropStateStore(null, stateProps);
        this.fieldValidationStore = new FieldValidationStore();
        this.translateStore = new TranslateStore(this);
    }
}
export default NoticeRootStore;
export function useNoticeStores() {
    return React.useContext(MobXProviderContext);
}
//# sourceMappingURL=NoticeRootStore.js.map